export const useDelayedSubmit = () => {
  const delayedSubmit = (callback: (event: any) => Promise<void>) => (event: any) => {
    setTimeout(() => {
      callback(event)
    }, 200)
  }

  return delayedSubmit
}
